import React from 'react';
import './Header.css';
import Avatar from './UserAvatar';

const Header = () => (
  <header className="header">
    <div className="header-inner">
      <img src="/optimo-logo.svg" alt="OPTiMO Logo" className="logo-img" />
      <div className="app-title">J.R.R. Token</div>
      <Avatar />
    </div>
  </header>
);

export default Header; 